import { cva } from 'class-variance-authority'

export const DropdownChevronStyles = cva([], { variants: {} })
